module.exports = __webpack_public_path__ + "img/steps-bg-2.c37f9c9a.svg";